<h2 mat-dialog-title>Tutorial 2 - Emettere fatture</h2>

    <mat-dialog-content>

      <p>Ora sei pronto per fatturare. Il processo di creazione di una fattura può essere ostico all’inizio, ma ci prenderai la mano. Basta seguire questi step. Ricorda che per creare una fattura puoi andare semplicemente alla sezione<span class="inline-icon">
          <mat-icon>note_add</mat-icon>
        </span>
      <u class="component-link" (click)="goToNewInvoice()">Fatturazione > Nuova fattura</u>
    .
    </p>
      <h6>Seleziona il cliente</h6>
      <p>Seleziona il tuo cliente, puoi cercarlo rapidamente in anagrafica con l'apposita barra di ricerca. In basso, vedrai 4 sezioni. Qui puoi gestire e registrare tutti gli aspetti della tua fattura. Vediamoli nel dettaglio.</p>
      <h6>Documento</h6>
      <p>Questa sezione contiene informazioni essenziali, come:</p>
        <ul>
          <li>Numero progressivo della fattura</li>
          <li>Oggetto della fattura</li>
          <li>Lingua</li>
          <li>Eventuali note per il cliente</li>
        </ul>
        <p><u>Nota bene:</u> il numero progressivo della fattura deve essere univoco e seguire una numerazione progressiva durante l’anno, senza salti. Controlla sempre bene questo campo prima di inviare! {{ sourceLabels[data.organization.source || ''] || "L'App" }} riconosce in automatico l’ultimo progressivo che hai inserito durante l’anno in corso, ma non può sapere se hai effettuato operazioni cona altri servizi di fatturazione esterni nel frattempo</p>
      <h6>Fatturazione</h6>
      <p>Qui inserirai:</p>
        <ul>
          <li>Il metodo di pagamento scelto</li>
          <li>Il tuo IBAN da inviare al cliente</li>
          <li>La data di emissione</li>
          <li>I termini di pagamento (in giorni)</li>
          <li>Eventuale marca da bollo (a carico tuo o del cliente)</li>
          <li>Eventuali dati aggiuntivi della fattura (campi opzionali)</li>
        </ul>
      <p>La data di pagamento prevista viene calcolata in automatico in base ai termini di pagamenti scelti. Ci sono alcuni campi da tenere in considerazione per il buon esito dell’invio:</p>
        <ul>
          <li>Fattura prestazione sanitaria: spunta questo campo se vuoi creare una fattura per prestazioni sanitarie. Ricorda che in questo caso NON verrà inviata all’Agenzia delle Entrate, come da normativa vigente. Sarà una semplice fattura cartacea registrata dal nostro Sistema e sulla tua App.</li>
          <li>Bollo: per i forfettari come te è obbligatorio per fatture di importo superiore a 77,47 €. Ricorda di indicarlo e l’importo finale della fattura verrà calcolato in automatico</li>
        </ul>
      <h6>Prestazione</h6>
      <p>Questo è il cuore della tua fattura. Per cosa ti stai facendo pagare dal tuo cliente? Per ogni prodotto o servizio fornito, inserisci:</p>
        <ul>
          <li>Descrizione</li>
          <li>Quantità</li>
          <li>Prezzo unitario</li>
          <li>Unità di misura</li>
          <li>Sconto eventuale</li>
        </ul>
      <p>Il totale di ogni prestazione viene calcolato in automatico. Man mano che registri le singole prestazioni, puoi notare il Riepilogo in fondo alla pagina che viene aggiornato.</p>
      <h6>Contributi</h6>
      <p>Eccoci arrivati alla sezione che contiene rivalsa INPS, rtienute e Cassa previdenziale. Puoi inserire una registrazione per ognuna di queste tre categorie. Anche in questo caso, il Riepilogo finale viene calcolato in automatico di conseguenza.</p>
      <h6>Riepilogo</h6>
      <p>Questa sezione contiene il riepilogo degli importi inseriti per le singole prestazioni, il resoconto della parte contributiva e eventuale marca da bollo. Se vuoi, puoi segnare questa fattura come già pagata. Non ci saranno conseguenze particolari sull’invio, serve solo all’App per capire se hai incassato la fattura e aggiornare la tua dashboard. Ricorda che puoi visualizzare l'anteprima del documento in qualsiasi momento cliccando su <strong>Anteprima</strong></p>
      <p>Arriva ora la scelta più importante:</p>
      <p>Se scegli <strong>Salva bozza</strong>, la tua fattura verrà salvata solo come bozza. Potrai modificare alcuni campi e inviarla in seguito con il tasto Pubblica. Se invece scegli <strong>Invia</strong>, la fattura viene chiusa e inoltrata direttamente al Sistema di Interscambio dell’Agenzia delle Entrate (SDI). Ottimo lavoro! Ora il cliente potrà pagarti. </p>


    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button
        matButton="filled"
        mat-dialog-close
        class="izy-button-primary custom-button-border">
        <mat-icon>check</mat-icon>
        Ok, torna ai tutorial
      </button>
    </mat-dialog-actions>
